module.exports = __webpack_public_path__ + "img/shop-similar-camera-16.bb9b878.svg";